<template>
    <div class="nav-top"> 
        <TopNav />
        <BottomNav v-if="login" :active="view"/>
    </div>
    <div :class="['content',login?'':'b-0']">
        <AllProducts v-if="(login && view === 'dashboard') || view === 'show-public'" />
        <UserQrCodeScan v-else-if="view === 'show-user-card'" :id="id"/>
        <ProductForm v-else-if="login && view === 'add-product'" :edit="false"/>
        <ProductForm v-else-if="login && view === 'edit-product'" :edit="true" :id="id"/>
        <AllReactions v-else-if="login && view === 'reaction-list'" />
        <ManageProduct v-else-if="login && view === 'manage-product'" />
        <UserSetting v-else-if="login && view === 'user-setting'" />
        <ShowProduct v-else-if="login && view === 'show-product'" :id="id"/>
        <AllChatBox v-else-if="login && view === 'chat-list'" :one="false"/>
        <AllChatBox v-else-if="login && view === 'show-chat-product'" :one="true" :productId="id"/>
        <AllChatBox v-else-if="login && view === 'show-chat-user'" :one="true" :userId="id"/>
        <AddFactor v-else-if="login && view === 'add-factor'" :id="id"/>
        <ManageFactor v-else-if="login && view === 'manage-factor'"/>
        <ResponseFactor v-else-if="login && view === 'response-factor'" :factorId="id" :factor="props.factor" :mobile="props.mobile" :packId="props.packId"/>
        <p v-else>نمایش مشخصی یافت نشد</p>
    </div>
    <div v-if="login && menu.isOpen" class="menu-modal" @click.self="menu.close">
        <div class="menu-content">
            <button class="close-btn" @click="menu.close">×</button>
            <ExteraMenu v-if="view === 'dashboard'||view === 'show-public'||view === 'show-user-card'" :chat="true" :list="true" :add="true" :manage="true" :setting="true"/>
            <ExteraMenu v-else-if="view === 'add-product'" :chat="true" :list="true" :add="false" :manage="true" :setting="true"/>
            <ExteraMenu v-else-if="view === 'edit-product'" :chat="true" :list="true" :add="false" :manage="true" :setting="true"/>
            <ExteraMenu v-else-if="view === 'reaction-list'" :chat="true" :list="false" :add="true" :manage="true" :setting="true"/>
            <ExteraMenu v-else-if="view === 'manage-product'" :chat="true" :list="true" :add="true" :manage="false" :setting="true"/>
            <ExteraMenu v-else-if="view === 'show-product'" :chat="true" :list="true" :add="true" :manage="false" :setting="true"/>
            <ExteraMenu v-else-if="view === 'add-factor'" :chat="true" :list="true" :add="true" :manage="false" :setting="true"/>
            <ExteraMenu v-else-if="view === 'manage-factor'" :chat="true" :list="true" :add="true" :manage="false" :setting="true"/>
            <ExteraMenu v-else-if="view === 'response-factor'" :chat="true" :list="true" :add="true" :manage="false" :setting="true"/>
            <ExteraMenu v-else-if="view === 'user-setting'" :chat="true" :list="true" :add="true" :manage="true" :setting="false"/>
            <ExteraMenu v-else-if="view === 'chat-list'" :chat="false" :list="true" :add="true" :manage="true" :setting="true"/>
            <ExteraMenu v-else-if="view === 'show-chat-product'" :chat="false" :list="true" :add="true" :manage="true" :setting="true"/>
            <ExteraMenu v-else-if="view === 'show-chat-user'" :chat="false" :list="true" :add="true" :manage="true" :setting="true"/>
            <p v-else>نمایش مشخصی یافت نشد</p>
        </div>
    </div>
</template>
<script setup>
    import TopNav from '@/components/dashboard/menus/TopNav.vue';
    import BottomNav from '@/components/dashboard/menus/BottomNav.vue';
    import ExteraMenu from '@/components/dashboard/menus/ExteraMenu.vue';
    import AllProducts from '@/components/dashboard/bodys/product/AllProducts.vue';
    import ProductForm from '@/components/dashboard/bodys/product/ProductForm.vue';
    import ManageProduct from '@/components/dashboard/bodys/product/ManageProduct.vue';
    import ShowProduct from '@/components/dashboard/bodys/product/ShowProduct.vue';
    import AllReactions from '@/components/dashboard/bodys/product/AllReactions.vue';
    import UserSetting from '@/components/user/UserSetting.vue';
    import AllChatBox from '@/components/dashboard/bodys/chat/AllChatBox.vue';
    import AddFactor from '@/components/dashboard/bodys/factor/AddFactor.vue';
    import ManageFactor from '@/components/dashboard/bodys/factor/ManageFactor.vue';
    import ResponseFactor from '@/components/dashboard/bodys/factor/ResponseFactor.vue';
    import { computed, defineProps, onMounted } from 'vue'
    import { useMenuStore } from '@/stores/menu'
    import { polling } from '@/composables/polling'
    import { useUserStore } from '@/stores/user'
    import { isDefrentUserData } from '@/composables/polling/isDefrentUserData'
    import UserQrCodeScan from '@/components/user/scan/UserQrCodeScan.vue';
    import router from '@/router';
    const menu = useMenuStore()
    const user = useUserStore()
    const props = defineProps({
        view: String,
        id: [String, Number],
        factor:{type:String,default:''},
        mobile:{type:String,default:''},
        packId:{type:Number,default:0}
    })
    const id = computed(()=> {
        return props.id
    })
    const view = computed(()=>{
        return props.view
    })
    polling( 
        () => user.fetchUserInfo(),
        {
            oldData:user.card,
            intervalMs: 6000,
            isDifferent: (newData) => isDefrentUserData(user.card,newData),
            onChange: (allNewProduct) => {
                if(isDefrentUserData(user.card,allNewProduct??[])){
                    user.setUserInfo(allNewProduct??[])  
                }
            }
        }
    )
    const login = computed(()=>{
        return user.isLoggedIn()
    })
    onMounted(()=>{
        if(view.value==='dashboard'){
            if(user.showTemplateAfterLogin!==''){
                router.push({ path: user.showTemplateAfterLogin }).then(()=>{
                    user.resetLoginNeed()
                })
            }
        }
    })
</script>
<style scoped>
    .menu-modal {
        position: fixed;
        inset: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
        display: flex;
        justify-content: flex-end;
    }
    .menu-content {
        width: 220px;
        background: white;
        height: 100%;
    }
    .close-btn {
        font-size: 20px;
        border: none;
        background: transparent;
        cursor: pointer;
        float: left;
        position:absolute;
    }
    .nav-top,.content{
        position: fixed;
        box-shadow: 0 0 6px grey;
        left: 0;
        right: 0;
        box-sizing: border-box;
        border: 1px solid #9b7ca9c4;
    }
    .nav-top{
        height: 60px;
        z-index: 9;
        top: 0;
    }
    .content{
        background-origin: border-box;
        height: auto;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        top: 60px;
        bottom: 0;
        padding: 10px;
        height: auto;
        overflow-y: auto;
        overflow-x: hidden;
    }
    @media screen and (max-width:600px){
        .menu-modal{
            display:none !important;
        }
        .content{
            bottom: 50px;
        }
        .b-0{
            bottom: 0 !important;
        }
    }
</style>